/*
App js
*/
(function($) {
	// Cookie bar
	//console.log("hello")
	// $('.js-cookie-dismiss').on('click', function(e){
	// 	e.preventDefault();
	// 	$.cookie('ms_cookieconsent', 'true', {expires: 28, path: '/'});
	// 	$('.js-cookie-bar').slideUp();
	// })

	// if (!$.cookie('ms_cookieconsent')) {
	// 	$('.js-cookie-bar').slideDown();
	// }

	// END Cookie Bar

	function equalheight(container){

		var currentTallest = 0,
			currentRowStart = 0,
			rowDivs = new Array(),
			$el,
			topPosition = 0;

		$(container).each(function() {
			$el = $(this);

			$($el).height('auto');

			topPosition = $el.position().top;

			if (currentRowStart != topPosition) {
				for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
					rowDivs[currentDiv].height(currentTallest);
				}

				rowDivs.length = 0; // empty the array
				currentRowStart = topPosition;
				currentTallest = $el.height();
				rowDivs.push($el);
			} else {
				rowDivs.push($el);
				currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
			}

			for (var currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
				rowDivs[currentDiv].height(currentTallest);
			}
		});
	}

	$('.isvg').inlinesvg();

	$('.js-quicklinks-toggle').on('click', function(){
		$(this).stop().toggleClass('active');
		$('.js-quicklinks').stop().slideToggle();
		$('.js-page-overlay').stop().fadeToggle();
	});

	$('.js-search-toggle').on('click', function(){
		$(this).toggleClass('active');
		$('.js-search').stop().slideToggle();
		$('.js-page-overlay').stop().fadeToggle();
		$('.js-search .search-input').focus();
		if( $(this).is( ":button" ) && $(this).hasClass('active') ) {
			$(this).find('span').text('Close');
		} else {
			$(this).find('span').text('Search');
		}
	});

	$('.js-search-submit').on('click', function(){
		var $form = $(this).closest('form');
		if ( $form.find('.search-input').val() ) {
			$form.submit();
		}
	});

	$(".js-mobile-nav-toggle").on("touch click", function(){
		$(this).stop().toggleClass('active');
		$(".hamburger").stop().toggleClass("is-active");
		$('.mobile-nav').stop().slideToggle();
		// $('.js-page-overlay').stop().fadeToggle();
	});

	$(".js-mob-nav-expand").on("touch click", function(){
		$(this).toggleClass('open');
		$(this).closest('li').toggleClass('open');
		$(this).closest('li').find('ul').stop().slideToggle();
	});

	$('.js-bg').each(function(){
		var src = $(this).find('.js-img').attr('src'),
			bg = 'url(' + src + ') center / cover no-repeat';

		$(this).css({'background': bg});
		$(this).find('.js-img').css({'visibility' : 'hidden'});
	});

	$(window).on('load', function(){
		equalheight('.js-content-height');
		equalheight('.js-cta-height');
		equalheight('.cta-box .js-bg');
		equalheight('.js-related-tags-height');
	});

	$('.archive__year').on('touch click', function(e){
		e.preventDefault();
		$(this).parent().find('.archive__months').slideToggle();
	});

	$('.js-tag__side-nav').on('touch click', function(e){
		e.preventDefault();
		$(this).parent().find('.js-tag__side-nav-items').slideToggle();
	});

	$('.form__terms-link').on('touch click', function(e){
		e.preventDefault();
		$('.form__terms-copy').slideToggle();
	});

	if(location.hash === "#form-errors") {
  	$('.form__notification--error').toggle();
	}

	if(location.hash === "#thank-you") {
  	$('.form__notification--thank-you').toggle();
	}

	$('.js-reveal-button').on('touch click', function(e){
		e.preventDefault();
		$(this).siblings().toggleClass('contact__directions--show');
	});

	$('.js-show-more').on('touch click', function(e) {
		e.preventDefault();
		$(this).parent().find('.hidden').slideToggle();
		var buttonCopy = ($(this).text() == "Show more…") ? "Show less…" : "Show more…";
		$(this).text(buttonCopy);
	});

	var url = $(location).attr('href');
	var tagsCheck = url.split('/').reverse()[1];

	if(tagsCheck == "tags"){
		var tag = url.split('/').reverse()[0];
		$("a[data-tag=" + tag + "]").addClass("active-tag");
	}

	$('.js-add-active-state').addClass('active-tag');

	$('.js-scroll-to-tags').on('click', function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#info-and-resources").offset().top
		}, 500);
	})

	$(".js-v-center").each(function(){
		var containerHeight = $(this).parent().outerHeight();
		var elementHeight = $(this).outerHeight();
		var newMargin = (containerHeight - elementHeight) / 2;
		$(this).css("margin-top", newMargin + "px");
	});

	var currentFocusParent;

	$(".site-navigation a.nav-drop").on('focusin focusout', function(){
		if($(this).is(":focus")) {
			$(this).parent().addClass("child-in-focus");
			currentFocusParent = $(this).parent();
		} else {
			$(this).parent().removeClass("child-in-focus");
		}
	});

	$(".site-navigation .nav-dropdown a").on('focusin', function(){
		if($(this).closest(".nav-dropdown").parent() != currentFocusParent) {
			$(this).closest(".nav-dropdown").parent().addClass("child-in-focus");
			currentFocusParent = $(this).closest(".nav-dropdown").parent();
		}
	});

	$(".site-navigation .nav-dropdown a").on('focusout', function(){
		if ($(this).closest(".nav-dropdown").parent() != currentFocusParent) {
			$(this).closest(".nav-dropdown").parent().removeClass("child-in-focus");
		}
	});

	var mobileDrawer = {
		// props
		element: null,
		open: null,
		close: null,
		secondLevelButtons: null,

		// methods
		init: function() {
			this.element = $('.js-mobile-nav');
			this.open = $('.js-mobile-nav-open');
			this.close = $('.js-mobile-nav-close');
			this.secondLevelButtons = $('.js-second-level-toggle');
			this.open.on('click', this.openAction.bind(this));
			this.close.on('click', this.closeAction.bind(this));
			this.secondLevelButtons.on('click', this.toggleSecondLevel);
		},
		openAction: function() {
			this.element.addClass('mobile-nav--active');
		},
		closeAction: function() {
			this.element.removeClass('mobile-nav--active');
		},
		toggleSecondLevel: function(event) {
			event.target.closest('li').querySelector('.mobile-nav__list--second').classList.toggle('mobile-nav__list--second-active');
		},
	}
	mobileDrawer.init();

	$(".reciteme").click(function(i,e){
		loadService();
		return false;
	});

	// Accordion
	$('.accordion__row').click(function(){
		if($(this).hasClass('accordion__row--active')) {
			$('.accordion__row').removeClass('accordion__row--active').children('.accordion__content').slideUp();
		} else {
			$('.accordion__row').removeClass('accordion__row--active').children('.accordion__content').slideUp();
			$(this).addClass('accordion__row--active').children('.accordion__content').slideToggle();
		}
	});

	// Comments with Blitz
	// If we have comments script injected, load in the comments JS.
	async function loadCommentsScript() {
		const CommentsScript = document.createElement('script');
		const csrfName = await fetch('/actions/blitz/csrf/param').then(result => { return result.text(); });
		const csrfToken = await fetch('/actions/blitz/csrf/token').then(result => { return result.text(); });
		CommentsScript.onload = () => {
			console.log('Comments script now running');
			const elementId = '#' + document.querySelector('.comments').dataset.elementId;
			const settings = {
				'baseUrl': window.location.origin,
				'csrfTokenName': csrfName,
				'csrfToken': csrfToken,
				'translations': false,
				'recaptchaEnabled': false,
				'recaptchaKey': null,
			}
			new Comments.Instance(elementId, settings);
		}
		CommentsScript.src = '/js/vendor/comments.js';
		document.head.appendChild(CommentsScript);
	}

	// The `afterBlitzInject` event is triggered after each dynamic content tag is injected
	document.addEventListener('afterBlitzInject', function (event) {
		if (event.detail.uri == "/dynamic/comments") loadCommentsScript();
	});

})(jQuery);
